import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { AppEntryLink } from "@/components/navigation/AppEntryLink";

// Closing ink band — the last push. Primary CTA starts a session;
// the secondary explains the process first.
export function FinalCTA() {
  return (
    <section
      className="bg-ink px-6 py-24 text-center text-parchment max-[980px]:py-[72px] sm:px-8"
      aria-label="Get started"
    >
      <div className="lp-reveal mx-auto max-w-[720px]">
        <h2 className="mb-[22px] font-serif text-[42px] font-normal leading-[1.12] tracking-[-0.02em] max-[980px]:text-[28px]">
          The first appeal is the one most people never write.{" "}
          <em className="italic text-brick-soft">Write yours.</em>
        </h2>
        <p className="mx-auto mb-9 max-w-[540px] text-[15.5px] leading-[1.65] text-parchment/70">
          Drop your denial letter in. See the probability, see the policy language. Pay only if you
          want the full letter.
        </p>
        <div className="inline-flex flex-wrap items-center justify-center gap-3.5">
          <AppEntryLink
            to="/session"
            className="inline-flex items-center gap-2 rounded-full bg-parchment px-[22px] py-[13px] text-[14px] font-medium text-ink transition hover:-translate-y-px hover:bg-white"
          >
            Read my denial
            <ArrowRight size={16} aria-hidden />
          </AppEntryLink>
          <Link
            to="/how-it-works"
            className="inline-flex items-center gap-2 rounded-full border-[0.5px] border-parchment/25 px-[22px] py-[13px] text-[14px] font-medium text-parchment transition hover:border-parchment/50 hover:bg-parchment/[0.08]"
          >
            See how it works
          </Link>
        </div>
        <div className="mt-[30px] text-[11px] uppercase tracking-[0.1em] text-parchment/50">
          HIPAA-aware · No account · Purged in 24 hours
        </div>
      </div>
    </section>
  );
}
